import { checkRangeDate } from "./checkRangeDate";

const handleDate = (startDate, endDate) => {
    return checkRangeDate(startDate, endDate);
  };


  export {handleDate};